import type { Category } from '@/types/content';

export const categories: Category[] = [
  {
    slug: 'yule-redian',
    name: '娱乐热点',
    shortName: '热点',
    tagline: '话题背后的行业逻辑',
    description:
      '娱乐热点栏目聚焦当下的娱乐话题与行业现象，从内容生产、传播节奏到观众心理，把一条热搜拆开来看，帮你看懂热闹背后的运行逻辑。',
    intro:
      '我们不做简短的转发，而是把每一个正在被讨论的话题，放回它产生的语境里。这里讨论的是现象、是趋势、是行业怎么运转，而不是未经证实的私人传闻。',
    accent: 'primary',
    icon: 'ri-fire-line',
  },
  {
    slug: 'reju-zong',
    name: '热剧综',
    shortName: '剧综',
    tagline: '剧集综艺的观后观察',
    description:
      '热剧综栏目收录剧集与综艺的观后观察、类型趋势与制作方法讨论，从叙事结构、节奏设计到观众共鸣点，帮你看得更细一点。',
    intro:
      '追剧追综不只是消遣。这里会聊类型为什么扎堆、节奏如何影响口碑、慢综艺为何回潮，也会聊一档节目从爆红到降温的完整周期。',
    accent: 'accent',
    icon: 'ri-movie-2-line',
  },
  {
    slug: 'wangluo-regeng',
    name: '网络热梗',
    shortName: '热梗',
    tagline: '流行语从哪里来，往哪里去',
    description:
      '网络热梗栏目追踪流行语的诞生、扩散与翻红，用传播路径和语义变迁的视角，解释一个梗为什么能刷屏，又会怎样退场。',
    intro:
      '热梗是当代网络最鲜活的语言现场。我们记录它们从哪里冒出来、如何被加速传播、又为什么会在半年后被重新翻出来用一遍。',
    accent: 'secondary',
    icon: 'ri-emotion-happy-line',
  },
  {
    slug: 'guquan-guancha',
    name: '瓜圈观察',
    shortName: '观察',
    tagline: '围观也有方法论',
    description:
      '瓜圈观察栏目讨论吃瓜文化本身：围观的分寸、信息的辨别、讨论的边界，以及我们为什么会对别人的故事如此投入。',
    intro:
      '吃瓜是一种参与，也是一种选择。这个栏目想聊的是：怎样在热闹里保持清醒，怎样讨论而不伤害，怎样在信息不全时先按下暂停键。',
    accent: 'primary',
    icon: 'ri-eye-line',
  },
];

export const getCategory = (slug: string): Category | undefined =>
  categories.find((c) => c.slug === slug);